import { Injectable } from "@angular/core";
import { NavigationExtras, Params, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class LocaleRouterService {
  constructor(
    public readonly router: Router,
    private readonly translate: TranslateService) {
  }

  public games(queryParams?: Params): Promise<boolean> {
    return this.localizedNavigate(['games']);
  }

  public exit(queryParams: Params): Promise<boolean> {
    return this.localizedNavigate(['exit'], { queryParams });
  }

  public localizedNavigate(commands: any[], extras?: NavigationExtras): Promise<boolean> {
    return this.router.navigate(['/', this.translate.currentLang, ...commands], extras);
  } 
}